import { createSelector } from 'reselect'

import selectIntegrationCredentialsById from './selectIntegrationCredentialsById'

export default createSelector(selectIntegrationCredentialsById, byId =>
  Object.values(byId)
)
